import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMultiline, InputSelect, Layout, InputFile, InputPicklist, InputSwitch, InputUID } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './event-model';  //editable..
import SectionChecklist from '../section/section-checklist.component';
import PersonalinfoChecklist from '../personalinfo/personalinfo-checklist.component';
import EventList from './event-list.component';
import EventquizList from '../eventquiz/eventquiz-list.component';
import EventquizDelete from '../eventquiz/eventquiz-delete.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    id?: number;
    caption?: string;
    astemplate?: string;
    delete?: boolean;
    onDelete?: (data: any) => void;
    onLoadAll?: (data: any) => void;
    onError?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    delete: boolean;
}

export default class EventDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            delete: false,
        }
    }

    private deleteCount: number = 0;
    private eventCount: number = 0;

    private onLoad = (data: any) => {
        this.setState({datarow: data});
        this.eventCount += 1;
        data.eventCount = 1;
        this.props.onLoadAll?.(data);     
    }

    private onError = (data: any) => {
        this.setState({errors: data});
        this.props.onError?.(data)
    }

    private onLoadAllEvent = (data: any) => {
        this.eventCount += data?.eventCount;
        data.eventCount = 1;
        this.props.onLoadAll?.(data);
    }

    private onDeleteEvent = (data: any) => {
        this.deleteCount += data.deleteCount;
        data.deleteCount = 1;
        this.props.onDelete?.(data);
        if (!this.props.disableView && this.deleteCount>=this.eventCount) 
            setTimeout(() =>this.props.history?.goBack(), 1000);        
    }

    private onDelete = (data: any) => {
        if (!this.props.disableView) this.setState({delete: true});
        this.deleteCount += 1;
        data.deleteCount = 1;
        this.props.onDelete?.(data);     
    }

    render() {
        const isDelete = this.props.disableView? this.props.delete : this.state.delete;

        return (
            //editable..
            <>
            <BaseDelete history={this.props.history} id={this.props.id} caption={this.props.disableView? ' ' : this.state.datarow?.parent && 'Delete Event Section'} buttonCaption={this.props.disableView? ' ' : ''}
                model={Model} onLoad={this.onLoad} onError={this.onError} delete={this.props.delete} onDelete={this.onDelete} disableAutoBack disableBackButton={this.props.disableView} disableCard>                  
                
                {!this.props.disableView && 
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly />
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                        <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle}readOnly />
                        <InputSwitch name='usecamera' label='Use Camera' value={this.state.datarow.usecamera} readOnly/>
                        <InputSwitch name='extratime' label='Allow Extra Time' value={this.state.datarow.extratime} readOnly/>
                        {!this.state.datarow.parent && <>
                        <InputPicklist name='messagestart' label='Message to Send Invitation' value={this.state.datarow.messagestart} caption={this.state.datarow.messagestartCaption} readOnly/>
                        <InputPicklist name='messageend' label='Message to Send Result' value={this.state.datarow.messageend} caption={this.state.datarow.messageendCaption} readOnly/>
                        </>}
                        <InputPicklist name='section' label='Section' value='' caption={this.state.datarow.sectionCaption} readOnly={this.state.datarow.parent} disableAutoClose>
                            <SectionChecklist history={this.props.history} currentId={this.state.datarow.section} readOnly disableBackButton/>
                        </InputPicklist> 
                        {!this.state.datarow.parent &&
                        <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} readOnly/>
                        }
                        <InputPicklist name='participant' label='Participant' value='' caption={this.state.datarow.participantCaption} readOnly={this.state.datarow.parent} disableAutoClose>
                            <PersonalinfoChecklist history={this.props.history} caption='Selected Participant' currentId={this.state.datarow.participant} readOnly disableBackButton/>
                        </InputPicklist>
                        <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} readOnly/>
                        <InputDate name='enddate' label='End Date' value={this.state.datarow.enddate} readOnly/>
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>                  
                        <InputUID name='uid' label='QR Code' value={this.state.datarow.uid} error={this.state.errors?.uid} />
                    </>
                    },

                    {caption: 'Sections', child: 
                    this.state.datarow.id > 0 && this.props.history && this.state.datarow.eventquizLength === 0 &&
                        <EventList history={this.props.history} root={this.props.root} caption='Event Section' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },
                    
                    {caption: 'Questions', child: 
                    this.state.datarow.id > 0 && this.props.history && this.state.datarow.eventquizLength > 0 &&
                        <EventquizList history={this.props.history} root={this.props.root} caption='Question' eventId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },
                ]}
                />
                }
            </BaseDelete>
            
            {this.state.datarow.eventquiz?.map((d: any) => {
                return ( <EventquizDelete key={d.id} history={this.props.history} id={d.id} delete={isDelete} disableView/> )
            })}

            {this.state.datarow.event?.map((d: any) => {
                return ( <EventDelete key={d.id} history={this.props.history} id={d.id} onLoadAll={this.onLoadAllEvent} delete={isDelete} onDelete={this.onDeleteEvent} disableView/> )
            })}       
            
            </>
        )
    }
}